import { tokens } from "../tokens";

export const en = {
  [tokens.common.languageChanged]: "Languange Changed",
  [tokens.nav.auth]: "Auth",
  [tokens.nav.create]: "Add",
  [tokens.nav.dashboard]: "Dashboard",
  [tokens.nav.details]: "Details",
  [tokens.nav.edit]: "Edit",
  [tokens.nav.error]: "Error",
  [tokens.nav.files]: "Files",
  [tokens.nav.forgotPassword]: "Forgot Password",
  [tokens.nav.list]: "List",
  [tokens.nav.login]: "Login",
  [tokens.nav.mail]: "Mail",
  [tokens.nav.overview]: "Overview",
  [tokens.nav.profile]: "Profile",
  [tokens.nav.register]: "Register",
  [tokens.nav.resetPassword]: "Reset Password",
  [tokens.nav.editSite]: "Edit Site",
  [tokens.nav.editMeter]: "Edit Meter",
  [tokens.nav.readings]: "Flow & Pressure Readings",
  [tokens.nav.graph]: "Graph Viewer",
  [tokens.nav.dailyCons]: "Daily Consumption",
  [tokens.nav.monthlyCons]: "Monthly Consumption",
  [tokens.nav.sites]: "Sites",
  [tokens.nav.settings]: "Settings",
  [tokens.nav.jobSummary]: "Job Summary",
  [tokens.nav.logViewer]: "Log Viewer",
  [tokens.nav.logout]: "Logout",
  [tokens.nav.loggerType]: "Meter Type",
  [tokens.nav.telemetry]: "Telemetry",
  [tokens.nav.administration]: "Administration",
  [tokens.nav.roles]: "Roles",
  [tokens.nav.users]: "Users",
  [tokens.nav.changePassword]: "Change Password",
  [tokens.nav.audit]: "Audit Trail",
  [tokens.nav.stations]: "Stations",
  [tokens.nav.rtus]: "RTUs",
  [tokens.nav.waterQuality]: "Water Quality",
  [tokens.nav.hydrology]: "Hydrology",
  [tokens.nav.alarms]: "Alarms",
  [tokens.nav.reports]: "Reports",
  [tokens.nav.inSituSampling]: "In Situ Sampling",
  [tokens.msg.getSupport]:
    "If you have any problem regarding the system, please reach us at ",
  [tokens.msg.loginError]: "Login failed. Please check your email and password",
  [tokens.msg.deleteSuccess]: "Successfully deleted",
  [tokens.msg.deleteFailed]: "Failed to delete",
  [tokens.msg.checkFormErrors]: "Please check and fix the form errors",
  [tokens.msg.noRecordsFound]: "No records found",
  [tokens.msg.atLeastOneParameterRequired]:
    "At least one water quality parameter is required",
  [tokens.msg.reportCodeAutoGenerated]:
    "Report serial number will be automatically generated when saved",
  [tokens.label.systemName]: "Water Quality Monitoring System",
  [tokens.label.email]: "Email Address",
  [tokens.label.password]: "Password",
  [tokens.label.forgetPassword]: "Forget Password?",
  [tokens.label.continue]: "Continue",
  [tokens.label.systemShortName]: "WQMS",
  [tokens.label.siteNameHint]: "Hint of Site Name",
  [tokens.label.siteName]: "Site Name",
  [tokens.label.filters]: "Filters",
  [tokens.label.dateRange]: "Date Range",
  [tokens.label.dateFrom]: "From",
  [tokens.label.dateTo]: "To",
  [tokens.label.from]: "From",
  [tokens.label.to]: "To",
  [tokens.label.all]: "All",
  [tokens.label.sourcePoint]: "Source Point",
  [tokens.label.view]: "View",
  [tokens.label.districts]: "Districts",
  [tokens.label.siteDetails]: "Site Details",
  [tokens.label.siteCode]: "Site Code",
  [tokens.label.manufacturer]: "Manufacturer",
  [tokens.label.modelNo]: "Model No",
  [tokens.label.size]: "Size",
  [tokens.label.startDate]: "Start Date",
  [tokens.label.modemType]: "Modem Type",
  [tokens.label.partNo]: "Part No",
  [tokens.label.description]: "Description",
  [tokens.label.firmwareVersion]: "Firmware Version",
  [tokens.label.hardwareVersion]: "Hardware Version",
  [tokens.label.powerSource]: "Power Source",
  [tokens.label.antennaType]: "Antenna Type",
  [tokens.label.coordinateX]: "Latitude",
  [tokens.label.coordinateY]: "Longitude",
  [tokens.label.elevation]: "Elevation",
  [tokens.label.readings]: "Readings",
  [tokens.label.datetime]: "Date & Time",
  [tokens.label.time]: "Time",
  [tokens.label.editSite]: "Edit Site",
  [tokens.label.viewChart]: "Graph Viewer",
  [tokens.label.noDataFound]: "No data found",
  [tokens.label.codeRequired]: "Code is required",
  [tokens.label.nameRequired]: "Name is required",
  [tokens.label.invalidPostcode]: "Invalid Postcode",
  [tokens.label.siteUpdated]: "Site info successfully updated",
  [tokens.label.errorOccurred]: "Error occurred",
  [tokens.label.accountNo]: "Account No",
  [tokens.label.address1]: "Address 1",
  [tokens.label.address2]: "Address 2",
  [tokens.label.address3]: "Address 3",
  [tokens.label.postcode]: "Postcode",
  [tokens.label.city]: "City",
  [tokens.label.district]: "District",
  [tokens.label.editMeter]: "Edit Meter",
  [tokens.label.serialNo]: "Serial No",
  [tokens.label.meterType]: "Meter Type",
  [tokens.label.startRead]: "First Read",
  [tokens.label.endDate]: "End Date",
  [tokens.label.endRead]: "Last Read",
  [tokens.label.update]: "Update",
  [tokens.label.selectDistrict]: "Select District",
  [tokens.label.selectMeterType]: "Select Meter Type",
  [tokens.label.siteList]: "Site List",
  [tokens.label.siteSearch]: "Search site name",
  [tokens.label.highestHourly]: "Highest Hourly",
  [tokens.label.yesterdayDiff]: "Yd Diff",
  [tokens.label.highestDaily]: "Highest Daily",
  [tokens.label.monthDiff]: "Prev Month Diff",
  [tokens.label.flowCount]: "Reading Count",
  [tokens.label.runDate]: "Running Date",
  [tokens.label.runStart]: "Running Start",
  [tokens.label.runEnd]: "Running End",
  [tokens.label.timeTaken]: "Time Taken",
  [tokens.label.totalData]: "Total Data",
  [tokens.label.totalProcessed]: "Total Processed",
  [tokens.label.runStatus]: "Process Status",
  [tokens.label.showProcessIncompleteOnly]:
    "Show Total Data \u2260 Total Processed Only",
  [tokens.label.complete]: "Complete",
  [tokens.label.incomplete]: "Incomplete",
  [tokens.label.nodata]: "No Data",
  [tokens.label.viewer]: "Viewer",
  [tokens.label.timeTakenOpt1]: "{0} minutes and {1} seconds",
  [tokens.label.timeTakenOpt2]: "{0} minute and {1} seconds",
  [tokens.label.timeTakenOpt3]: "{0} seconds",
  [tokens.label.jobSummaryDesc]: "Job schedule and process result",
  [tokens.label.operationDesc]:
    "Operation process is scheduled every 12AM and 12PM.",
  [tokens.label.date]: "Date",
  [tokens.label.result]: "Result",
  [tokens.label.flowCountIncomplete]: "Incomplete Flow Count",
  [tokens.label.sharpIncreaseFlowSma]: "Sharp Increase in flow SMA",
  [tokens.label.onlineSite]: "Online Meter Sites",
  [tokens.label.offlineSite]: "Offline Meter Sites",
  [tokens.label.topConsumer]: "Top Consumer",
  [tokens.label.topConsumerDesc]:
    "10 customers with highest water consumption within this month",
  [tokens.label.lastJobRun]: "Last job run was",
  [tokens.label.nextJobRun]: "Next job run is",
  [tokens.label.days]: "day(s)",
  [tokens.label.hours]: "hour(s)",
  [tokens.label.minutes]: "minute(s) ago",
  [tokens.label.editSftp]: "SFTP",
  [tokens.label.editMnHours]: "`Min Night Hours`",
  [tokens.label.configUpdated]: "Config successfully updated",
  [tokens.label.sftpHost]: "Host",
  [tokens.label.sftpPort]: "Port",
  [tokens.label.sftpUser]: "Username",
  [tokens.label.sftpPw]: "Password",
  [tokens.label.sftpRemoteDir]: "Remote Dir",
  [tokens.label.mnStart]: "Hour Start",
  [tokens.label.mnEnd]: "Hour End",
  [tokens.label.sftpHostRequired]: "SFTP Host is required",
  [tokens.label.sftpPortRequired]: "SFTP Port is required",
  [tokens.label.sftpUserRequired]: "SFTP User is required",
  [tokens.label.sftpRemoteDirRequired]: "SFTP Remote Dir is required",
  [tokens.label.active]: "Active",
  [tokens.label.inactive]: "Inactive",
  [tokens.label.address]: "Address",
  [tokens.label.logType]: "Log Type",
  [tokens.label.logDate]: "Log Date",
  [tokens.label.noLog]: "No log found",
  [tokens.label.allDistricts]: "All Districts",
  [tokens.label.editLoggerType]: "Edit Meter Type",
  [tokens.label.loggerTypeUpdated]: "Meter Type successfully updated",
  [tokens.label.descRequired]: "Description is required",
  [tokens.label.manufacturerRequired]: "Manufacturer is  required",
  [tokens.label.parNoRequired]: "Part No is required",
  [tokens.label.back]: "Back",
  [tokens.label.loggerDetails]: "Meter Type Details",
  [tokens.label.createLoggerType]: "Add Meter Type",
  [tokens.label.createSite]: "Add Site",
  [tokens.label.selectLoggerType]: "Select Meter Type",
  [tokens.label.loggerSerialNo]: "Meter Serial No",
  [tokens.label.loggerTypeRequired]: "Meter Type is required",
  [tokens.label.loggerSnRequired]: "Meter Serial No is required",
  [tokens.label.position]: "Position",
  [tokens.label.districtRequired]: "District is required",
  [tokens.label.largeLogFile]:
    "File is downloaded as the log size is more than 5MB",
  [tokens.label.clientName]: "Lembaga Sumber Air Negeri Kedah",
  [tokens.label.clientNameShort]: "LSANK",
  [tokens.label.roleName]: "Role Name",
  [tokens.label.roleAccess]: "Role Access",
  [tokens.label.actions]: "Actions",
  [tokens.label.editRole]: "Update Role",
  [tokens.label.language]: "Set Language",
  [tokens.label.theme]: "Set Theme",
  [tokens.label.moduleName]: "Module Name",
  [tokens.label.access]: "Access",
  [tokens.label.roleFilterKey]: "Key in role name here",
  [tokens.label.addRole]: "Add Role",
  [tokens.label.moduleAccess]: "Module Access",
  [tokens.label.save]: "Save",
  [tokens.label.scrollMore]: "Scroll to see more options",
  [tokens.label.maxLength]: "Maximum length is ",
  [tokens.label.minLength]: "Minimum length is ",
  [tokens.label.fieldRequired]: "This field is required",
  [tokens.label.roleUpdated]: "Successfully created/updated role info",
  [tokens.label.pressEnter]: "Hit 'Enter' after type in keyword",
  [tokens.label.name]: "Name",
  [tokens.label.username]: "Username",
  [tokens.label.fullName]: "Full Name",
  [tokens.label.phone]: "Phone No",
  [tokens.label.role]: "Role",
  [tokens.label.lastLogin]: "Last Login",
  [tokens.label.createdDate]: "Added Date",
  [tokens.label.createdBy]: "Added By",
  [tokens.label.modifiedDate]: "Updated Date",
  [tokens.label.modifiedBy]: "Updated By",
  [tokens.label.userFilterKey]: "Key in full name or username here",
  [tokens.label.viewUser]: "User Info",
  [tokens.label.editUser]: "Update User",
  [tokens.label.changePassword]: "Change Password",
  [tokens.label.addUser]: "Add User",
  [tokens.label.selectRole]: "Select Role",
  [tokens.label.passwordMin]: "Must be at least 8 characters.",
  [tokens.label.passwordMatches]:
    "Min 8 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.",
  [tokens.label.confirmPasswordMatches]: "Passwords must match",
  [tokens.label.confirmPassword]: "Password (Confirm)",
  [tokens.label.invalidPhone]: "Phone contains 9 - 11 characters",
  [tokens.label.invalidPhoneExtra]: "Phone must contain numbers only",
  [tokens.label.validEmail]: "Must be a valid email address",
  [tokens.label.userUpdated]: "Successfully created/updated user info",
  [tokens.label.selectOptionRequired]: "Please select an option",
  [tokens.label.action]: "Action",
  [tokens.label.allActions]: "All Actions",
  [tokens.label.entityName]: "Entity",
  [tokens.label.allEntityNames]: "All Entities",
  [tokens.label.ipAddress]: "IP Address",
  [tokens.label.userAgent]: "User Agent",
  [tokens.label.note]: "Sorry, no additional information available",
  [tokens.label.beforeState]: "Before State",
  [tokens.label.afterState]: "After State",
  [tokens.label.reason]: "Reason",
  [tokens.label.activate]: "Activate",
  [tokens.label.deactivate]: "Deactivate",
  [tokens.label.userStatusUpdated]: "User status changed successfully",
  [tokens.label.passwordChangeSuccess]:
    "Password changed successfully. You will be logged out after {{time}} seconds.",
  [tokens.label.logoutNow]: "Logout Now",
  [tokens.label.export]: "Export",
  [tokens.label.newPassword]: "New Password",
  [tokens.label.stationFilterKey]: "Enter station code or name",
  [tokens.label.rtuFilterKey]: "Enter RTU serial no or model no",
  [tokens.label.valueInNumber]: "Value must be in decimal number",
  [tokens.label.addStation]: "Add Station",
  [tokens.label.updateStation]: "Update Station",
  [tokens.label.viewStation]: "Station Info",
  [tokens.label.stationUpdated]: "Successfully created/updated station info",
  [tokens.label.stationName]: "Station Name",
  [tokens.label.stationCode]: "Station Code",
  [tokens.label.location]: "Location",
  [tokens.label.rtu]: "RTU",
  [tokens.label.selectRtu]: "Select RTU",
  [tokens.label.coordX]: "Latitude",
  [tokens.label.coordY]: "Longitude",
  [tokens.label.distanceToStation]: "Distance to Station (km)",
  [tokens.label.getLocation]: "Get Current Location",
  [tokens.label.rtuUpdated]: "Successfully created/updated RTU info",
  [tokens.label.addRTU]: "Add RTU",
  [tokens.label.editRTU]: "Update RTU",
  [tokens.label.viewRTU]: "RTU Info",
  [tokens.label.accessKey]: "Access Key",
  [tokens.label.getAccessKey]: "Get Access Key",
  [tokens.label.viewAccessKey]: "See Access Key",
  [tokens.label.brand]: "Brand",
  [tokens.label.rtuStatusUpdated]: "RTU status updated successfully",
  [tokens.label.rtuKeyUpdated]: "RTU access key updated successfully",
  [tokens.label.rtuKeyDesc]:
    "Access key is required for RTU to access and transmit data to WQMS API. Do you want to generate new access key for this RTU?",
  [tokens.label.close]: "Close",
  [tokens.label.copyToClipboard]: "Copy to Clipboard",
  [tokens.label.copied]: "Copied!",
  [tokens.label.coordinate]: "Coordinate",
  [tokens.label.stationStatusUpdated]: "Station status updated successfully",
  [tokens.label.zoomIn]: "Zoom In",
  [tokens.label.viewDetails]: "View Station Detail",
  [tokens.label.viewOutlets]: "View Source Points",
  [tokens.label.addOutlet]: "Add Source Point",
  [tokens.label.editOutlet]: "Update Source Point",
  [tokens.label.viewOutlet]: "View Source Point",
  [tokens.label.outletName]: "Source Point Name",
  [tokens.label.regNo]: "Registration No",
  [tokens.label.outletUpdated]:
    "Successfully created/updated source point info",
  [tokens.label.outletStatusUpdated]:
    "Source Point status updated successfully",
  [tokens.label.loading]: "Processing...",
  [tokens.label.threshold]: "Parameter Limits",
  [tokens.label.alert]: "Alert",
  [tokens.label.paramName]: "Parameter Name",
  [tokens.label.paramShortName]: "Parameter Short Name",
  [tokens.label.paramUnit]: "Parameter Unit",
  [tokens.label.setLimit]: "Set Limit",
  [tokens.label.warningLimit]: "Warning Limit",
  [tokens.label.criticalLimit]: "Critical Limit",
  [tokens.label.thresholdUpdated]: "Successfully updated parameter limit",
  [tokens.label.largerThanCritical]:
    "Value should be equal or larger than critical limit",
  [tokens.label.largerThanWarning]:
    "Value should be equal or larger than warning limit",
  [tokens.label.lessThanCritical]:
    "Value should be equal or less than critical limit",
  [tokens.label.lessThanWarning]:
    "Value should be equal or less than warning limit",
  [tokens.label.higherIsBetter]:
    "Warning limit must be equal or larger than critical limit",
  [tokens.label.hasTwoSides]: "Has two part of limits, upper and lower limit",
  [tokens.label.lowerIsBetter]:
    "Warning limit must be equal or smaller than critical limit",
  [tokens.label.alertEmailUpdated]: "Successfully added/updated alert email ",
  [tokens.label.updateEmail]: "Update Email Address",
  [tokens.label.removeEmail]: "Remove Email Address",
  [tokens.label.removeEmailConfirm]:
    "Are you sure want to remove this email address?",
  [tokens.label.continue]: "Continue",
  [tokens.label.alertEmailRemoved]: "Alert email is removed successfully",
  [tokens.label.outlet]: "Source Point",
  [tokens.label.selectMukim]: "Select Subdistrict",
  [tokens.label.mukim]: "Subdistrict",
  [tokens.label.note1]: "Notes",
  [tokens.label.stationOverview]: "Station (Overview)",
  [tokens.label.stationOverviewDesc]:
    "A picture of the station as a whole including the surroundings",
  [tokens.label.stationCloseUp]: "Station (Close Up)",
  [tokens.label.stationCloseUpDesc]: "A close up picture of the station",
  [tokens.label.stationOptional]: "Station (Optional)",
  [tokens.label.stationOptionalDesc]:
    "Optional picture of the station as additional reference",
  [tokens.label.noPicture]: "No picture available. Please upload",
  [tokens.label.ssmNo]: "Company Reg. No (SSM)",
  [tokens.label.outletOverview]: "Source Point (Overview)",
  [tokens.label.outletOverviewDesc]:
    "A picture of the source point premise/location as a whole including the surroundings",
  [tokens.label.outletCloseUp]: "Source Point (Close Up)",
  [tokens.label.outletCloseUpDesc]:
    "A close up picture of the source point outlet to the river",
  [tokens.label.outletOptional]: "Source Point (Optional)",
  [tokens.label.outletOptionalDesc]:
    "Optional picture of the source point as additional reference",
  [tokens.label.delete]: "Delete",
  [tokens.label.deleteOutlet]: "Delete Source Point",
  [tokens.label.deleteOutletConfirm]:
    "Are you sure to delete this source point? This action cannot be undone.",
  [tokens.label.outletRemoved]: "Source point is deleted successfully",
  [tokens.label.detailInfo]: "Details",
  [tokens.label.samplingData]: "Sampling Data",
  [tokens.label.samplingDate]: "Sampling Date",
  [tokens.label.readingDate]: "Reading Date",
  [tokens.label.parameters]: "Parameters",
  [tokens.label.missingData]: "Missing Data",
  [tokens.label.stationInfo]: "Station Info",
  [tokens.label.reading]: "Reading",
  [tokens.label.exportToExcel]: "Export to Excel",
  [tokens.label.station]: "Station",
  [tokens.label.displayReading]: "Display Readings",
  [tokens.label.readingData]: "Reading Data",
  [tokens.label.noDataToDisplay]: "No data to display",
  [tokens.label.seeStation]: "See stations",
  [tokens.label.seeAlarm]: "See alarms",
  [tokens.label.cleanRiver]: "Clean River",
  [tokens.label.slightlyPollutedRiver]: "Slightly Polluted River",
  [tokens.label.pollutedRiver]: "Polluted River",
  [tokens.label.alarmTriggered]: "Triggered Alarm",
  [tokens.label.wqi]: "Water Quality Index",
  [tokens.label.wqiDesc]: "WQI and parameters readings at each station",
  [tokens.label.inSituWqi]: "In-Situ WQI",
  [tokens.label.inSituWqiDesc]:
    "WQI readings at each in-situ sampling location",
  [tokens.label.openStationOverview]: "View Station Detail",
  [tokens.label.hydro]: "Hydrology",
  [tokens.label.hydroDesc]: "Hydrology readings at each station",
  [tokens.label.compareTime]: "Set Compare Time",
  [tokens.label.autoLoadStop]: "Auto refresh stopped",
  [tokens.label.autoLoadResume]: "Auto refresh resumed",
  [tokens.label.stopRefresh]: "Stop Auto Refresh",
  [tokens.label.refreshResume]: "Resume Auto Refresh",
  [tokens.label.last5alarms]: "Latest 5 alarms",
  [tokens.label.wqiStationDesc]: "WQI and parameters readings",
  [tokens.label.hydroStationDesc]: "Hydrology readings",
  [tokens.label.map]: "Map",
  [tokens.label.enterZenMode]: "Enter Zen Mode",
  [tokens.label.exitZenMode]: "Exit Zen Mode",
  [tokens.label.confirmLogout]: "Are you sure you want to logout?",
  [tokens.label.cancel]: "Cancel",
  [tokens.label.seeDashboard]: "See Public Dashboard",
  [tokens.label.date]: "Date",
  [tokens.label.generate]: "Generate",
  [tokens.label.dailyReport]: "Daily Reading Report",
  [tokens.label.monthlyReport]: "Monthly Reading Report",
  [tokens.label.stationSourcePointList]: "Station and Source Point List",
  [tokens.label.alarmReport]: "Alarm Report",
  [tokens.label.month]: "Month",
  [tokens.label.selectStationAndParameter]: "Select Station and Parameter",
  [tokens.label.selectAll]: "Select All",
  [tokens.label.deselectAll]: "Deselect All",
  [tokens.label.dailyAlarmReport]: "Daily Alarm Report",
  [tokens.label.monthlyAlarmReport]: "Monthly Alarm Report",
  [tokens.label.monthlyReportSummary]: "Monthly Reading Report Summary",
  [tokens.label.dailyReportSummary]: "Daily Reading Report Summary",
  [tokens.label.expectedData]: "Expected Data",
  [tokens.label.actualData]: "Actual Data",
  [tokens.label.missingData]: "Missing Data",
  [tokens.label.percentageMissingData]: "Percentage Missing Data",
  [tokens.label.parameterDetails]: "Parameter Details",
  [tokens.label.yes]: "Yes",
  [tokens.label.no]: "No",
  [tokens.label.totalExpectedData]: "Total Expected Data",
  [tokens.label.totalActualData]: "Total Actual Data",
  [tokens.label.totalMissingData]: "Total Missing Data",
  [tokens.label.monthlyReportFileTitle]: "Monthly_Report-",
  [tokens.label.dailyReportFileTitle]: "Daily_Reading_Report-",
  [tokens.label.alarmDesc]: "Alarm Description",
  [tokens.label.monthlyAlarmReportFileTitle]: "Monthly_Alarm_Report-",
  [tokens.label.dailyAlarmReportFileTitle]: "Daily_Alarm_Report-",
  [tokens.label.dailyReadings]: "Daily Readings",
  [tokens.label.stationSourceReport]: "Station and Source Point List",
  [tokens.label.stationDetails]: "Station Details",
  [tokens.label.rtuSerialNo]: "RTU Serial No",
  [tokens.label.rtuModelNo]: "RTU Model No",
  [tokens.label.rtuBrand]: "RTU Brand",
  [tokens.label.stationSourceReportFileTitle]: "Station_and_Source_Point",
  [tokens.label.sample]: "Sample",
  [tokens.label.keyWord]: "Keyword",
  [tokens.label.auditReportTitle]: "Audit_Logs-",
  [tokens.label.alarmReportTitle]: "Alarm_List-",
  [tokens.label.alarmCount]: "Alarm Count",
  [tokens.label.alarmCountByDate]: "Alarm Count By Date",
  [tokens.label.alarmFrequency]: "Alarm Frequency",
  [tokens.label.noAlarm]: "No Alarm",
  [tokens.label.low]: "Low",
  [tokens.label.medium]: "Medium",
  [tokens.label.high]: "High",
  [tokens.label.veryHigh]: "Very High",
  [tokens.label.alertEmailInstruction]:
    "Please enter the email of the user who will receive the warning notification.",
  [tokens.label.installedAt]: "Installed at",
  [tokens.label.sourcePointList]: "Source Point List",
  [tokens.label.stationOutletName]: "Station/Source Point",
  [tokens.label.sourcePointListSubtitle]: "Source point list and sampling data",
  [tokens.label.lastRefreshAt]: "Last refresh at",
  [tokens.label.emailToReceiveNotification]:
    "List of emails that will receive alert notifications",
  [tokens.label.emailNotification]: "Email Notification",
  [tokens.label.currentWQI]: "Current WQI",
  [tokens.label.upperLimit]: "Upper Limit",
  [tokens.label.lowerLimit]: "Lower Limit",
  [tokens.label.largerThanUpperCritical]: "Larger than upper limit value",
  [tokens.label.lessThanLowerCritical]: "Less than lower limit value",
  [tokens.label.acidity]: "Acidity",
  [tokens.label.alkalinity]: "Alkalinity",
  [tokens.label.lowerWarningLimit]: "Lower Warning Limit",
  [tokens.label.lowerCriticalLimit]: "Lower Critical Limit",
  [tokens.label.upperWarningLimit]: "Upper Warning Limit",
  [tokens.label.upperCriticalLimit]: "Upper Critical Limit",
  [tokens.label.kkmLimits]: "KKM Standards Limits",
  [tokens.label.jasLimits]: "JAS Standards Limits",
  [tokens.label.sendCommandGrabSample]: "Send Command Grab Sample",
  [tokens.label.sendCommandGrabSampleConfirm]:
    "Are you sure want to send command to grab sample?",
  [tokens.label.commandSent]:
    "The command is saved and is pending to be sent to RTU.",
  [tokens.label.commandFailed]: "Command failed",
  [tokens.label.seeCommandHistory]: "See Command History",
  [tokens.label.commandHistory]: "Command History",
  [tokens.label.mode]: "Mode",
  [tokens.label.publicView]: "Public View",
  [tokens.label.publicViewDesc]:
    "Water quality readings for public view. Check and approve to show in public view.",
  [tokens.label.approvedBy]: "Approved By",
  [tokens.label.approvedDate]: "Approved Date",
  [tokens.label.currentPublicView]: "Current WQI in Public View",
  [tokens.label.toBeApprovedPublicView]:
    "WQI To Be Approved for Public Viewing",
  [tokens.label.approve]: "Approve",
  [tokens.label.wqiApproveSuccess]: "WQI is approved successfully",
  [tokens.label.wqiApproveFailed]: "WQI approval failed",
  [tokens.label.approved]: "Approved",
  [tokens.label.wqiCancelSuccess]: "WQI cancellation is successful",
  [tokens.label.wqiCancelFailed]: "WQI cancellation failed",
  [tokens.label.noWQIApproved]: "No approval",
  [tokens.label.dataMaintenance]: "Data Maintenance",
  [tokens.label.dataMaintenanceDesc]: "Data maintenance for daily readings",
  [tokens.label.rtuDataFile]: "RTU Data File (WQI)",
  [tokens.label.rtuDataFileDesc]: "Upload RTU WQI data file in CSV format",
  [tokens.label.uploadRTUFile]: "Upload RTU Data File [WQI]",
  [tokens.label.uploadRTUFileDesc]:
    "Upload RTU data file for daily readings. Please make sure the file is in CSV format. Maximum file size is 20MB.",
  [tokens.label.fileExceedSize]:
    "Maximum file size exceeded. Please re-upload a smaller file.",

  [tokens.label.doNotCloseWindowWhileProcessing]:
    "Do not close the window while processing",
  [tokens.label.startProcess]: "Start Process",
  [tokens.label.processCompleted]: "Process completed",
  [tokens.label.processFailed]: "Process failed",
  [tokens.label.processInProgress]: "Process in progress",
  [tokens.label.addLocation]: "Add Location",
  [tokens.label.updateLocation]: "Update Location",
  [tokens.label.location]: "Location",
  [tokens.label.locationInfo]: "Location Info",
  [tokens.label.locationName]: "Location Name",
  [tokens.label.locationCode]: "Location Code",
  [tokens.label.locationView]: "Location View",
  [tokens.label.uploadLocationView]: "Upload Location View",
  [tokens.label.samplePoint]: "Sample Point",
  [tokens.label.uploadSamplePoint]: "Upload Sample Point",
  [tokens.label.surrounding]: "Surrounding",
  [tokens.label.uploadSurrounding]: "Upload Surrounding",
  [tokens.label.latestSamplingWQI]: "Latest Sampling WQI",
  [tokens.label.latestSamplingDate]: "Latest Sampling Date",
  [tokens.label.latestSamplingUpdatedBy]: "Latest Sampling Updated By",
  [tokens.label.sampleDate]: "Sample Date",
  [tokens.label.createdDate]: "Created Date",
  [tokens.label.sampledBy]: "Sampled By",
  [tokens.label.analyzedBy]: "Analyzed By",
  [tokens.label.labReference]: "Lab Reference",
  [tokens.label.remarks]: "Remarks",
  [tokens.label.temperature]: "Temperature",
  [tokens.label.latestReading]: "Latest Reading",
  [tokens.label.latestReadingDetails]: "Latest Reading Details",
  [tokens.label.wqiValue]: "WQI Value (Auto-calculated)",
  [tokens.label.wqiValueHelper]:
    "WQI is automatically calculated based on other parameters",
  [tokens.label.readingsTabInfo]:
    "Use this tab to record the latest water quality sampling reading for this location. Fill in the measured parameters and the WQI will be calculated automatically.",
  [tokens.label.samplingHistory]: "Sampling History",
  [tokens.label.editReading]: "Edit Reading",
  [tokens.label.addReading]: "Add Reading",
  [tokens.label.addNewReading]: "Add New Reading",
  [tokens.label.editReadingInfo]:
    "Records can be edited within 7 days from the created date.",
  [tokens.label.readingUpdated]: "Reading updated successfully",
  [tokens.label.readingCreated]: "Reading created successfully",
  [tokens.label.exportDate]: "Export Date",
  [tokens.label.totalRecords]: "Total Records",
  [tokens.label.exportSuccess]: "Export successful",
  [tokens.label.exportFailed]: "Export failed",
  [tokens.label.errorLoadingData]: "Error loading data",
  [tokens.label.searchKeyword]: "Search Keyword",
  [tokens.label.dateRangeSampling]: "Date Range Sampling",
  [tokens.label.resetFilters]: "Reset Filters",

  // Inspection Report
  [tokens.label.inspectionReport]: "Inspection Report",
  [tokens.label.inspectionReports]: "Inspection Reports",
  [tokens.label.createInspectionReport]: "Inspection Report Details",
  [tokens.label.editInspectionReport]: "Edit Inspection Report",
  [tokens.label.reportTitle]: "Report Title",
  [tokens.label.reportDate]: "Report Date",
  [tokens.label.reportStatus]: "Report Status",
  [tokens.label.reportNumber]: "Report Number",
  [tokens.label.reportCode]: "Report Serial Number",
  [tokens.label.fileNo]: "File Number",
  [tokens.label.pollutionComplaint]:
    "Water Source Pollution Complaint Inspection Report",
  [tokens.label.licensingInspection]:
    "License Application / Site Monitoring Inspection Report\n(Effluent Discharge Activity Regulations 2017)",
  [tokens.label.pdfPreview]: "PDF Preview",
  [tokens.label.inspectionReportPreview]: "Inspection Report Preview",

  // Location Section
  [tokens.label.locationInfo]: "Location Information",
  [tokens.label.district]: "District",
  [tokens.label.mukim]: "Mukim",
  [tokens.label.addressLine1]: "Address Line 1",
  [tokens.label.addressLine2]: "Address Line 2",
  [tokens.label.addressLine3]: "Address Line 3",
  [tokens.label.gpsCoordinates]: "GPS Coordinates",
  [tokens.label.latitude]: "Latitude",
  [tokens.label.longitude]: "Longitude",

  // Officers Section
  [tokens.label.officersInfo]: "Officers Information",
  [tokens.label.inspectionOfficers]: "Inspection Officers",
  [tokens.label.selectInspectionOfficers]: "Select inspection officers",
  [tokens.label.additionalOfficers]: "Additional Officers (Not in List)",
  [tokens.label.additionalOfficersPlaceholder]:
    "E.g.:\nOfficer Name 1\nOfficer Name 2\nOfficer Name 3\n...",
  [tokens.label.additionalOfficersHelper]:
    "Enter officer names not in the list, one name per line",
  [tokens.label.selectOfficers]: "Select Officers",
  [tokens.label.siteOfficer]: "Site Officer",
  [tokens.label.siteOfficerName]: "Officer / Supervisor / PIC Name at Site",
  [tokens.label.siteOfficerNamePlaceholder]: "Name of the officer on site",
  [tokens.label.siteOfficerPosition]:
    "Officer / Supervisor / PIC Position at Site",
  [tokens.label.siteOfficerPhone]: "Officer/Supervisor/PIC Phone at Site",
  [tokens.label.siteOfficerEmail]: "Officer/Supervisor/PIC Email at Site",
  [tokens.label.activityType]: "Activity Type",

  // Schedule & Timing
  [tokens.label.scheduleInfo]: "Inspection Date and Time",
  [tokens.label.inspectionDate]: "Inspection Date",
  [tokens.label.inspectionTime]: "Inspection Time",

  // Findings Section
  [tokens.label.findingsObservations]: "Findings & Observations",
  [tokens.label.checkboxInstruction]:
    "Tick ☑ if compliant. Specify further details if non-compliant.",
  [tokens.label.enforcementInstruction]:
    "Tick ☑ if notice is issued and fill in the serial no and notice details (optional).",
  [tokens.label.wasteDischarge]: "Waste Discharge",
  [tokens.label.dischargeSurfaceWater]: "Discharge to Surface Water",
  [tokens.label.dischargePublicSewer]: "Discharge to Public Sewer",
  [tokens.label.dischargeStormDrain]: "Discharge to Storm Drain",
  [tokens.label.dischargeOther]: "Other Discharge Method",
  [tokens.label.specifyOther]: "Please Specify",
  [tokens.label.treatmentFacilities]: "Treatment Facilities",
  [tokens.label.preliminaryTreatment]: "Preliminary Treatment",
  [tokens.label.primaryTreatment]: "Primary Treatment",
  [tokens.label.secondaryTreatment]: "Secondary Treatment",
  [tokens.label.tertiaryTreatment]: "Tertiary Treatment",
  [tokens.label.noTreatment]: "No Treatment",
  [tokens.label.environmentalIssues]: "Environmental Issues Observed",
  [tokens.label.odorComplaint]: "Odor Complaint",
  [tokens.label.colorDischarge]: "Colored Discharge",
  [tokens.label.foamFormation]: "Foam Formation",
  [tokens.label.solidWaste]: "Solid Waste",
  [tokens.label.oilGrease]: "Oil & Grease",
  [tokens.label.chemicalContainers]: "Chemical Containers",
  [tokens.label.siteConditions]: "Site Conditions",
  [tokens.label.adequateDrainage]: "Adequate Drainage System",
  [tokens.label.properBunding]: "Proper Bunding",
  [tokens.label.coveringStructure]: "Covering Structure",
  [tokens.label.securityFencing]: "Security Fencing",
  [tokens.label.warningSignage]: "Warning Signage",
  [tokens.label.compliance]: "Compliance Status",
  [tokens.label.validLicense]: "Valid Environmental License",
  [tokens.label.planApproved]: "Treatment Plan Approved",
  [tokens.label.recordsMaintained]: "Records Properly Maintained",
  [tokens.label.previousNonCompliance]: "Previous Non-Compliance",

  // New Findings Sections
  [tokens.label.licensingDocuments]: "Licensing/Document Completeness",
  [tokens.label.licenseCopyDisplayed]:
    "1. Copy of Effluent Discharge Activity License displayed at premises",
  [tokens.label.licenseStillValid]: "2. License still valid (not expired)",
  [tokens.label.effluentPlanAvailable]:
    "3. Effluent flow plan / treatment system plan kept at premises",
  [tokens.label.maintenanceRecordsAvailable]:
    "4. Effluent treatment system maintenance records",
  [tokens.label.monitoringRecordsAvailable]:
    "5. Parameter readings / monitoring records (if automated system @ manual report)",
  [tokens.label.labReportAvailable]:
    "6. Latest laboratory analysis report (< 6 months)",

  [tokens.label.treatmentSystem]: "Effluent Treatment System",
  [tokens.label.treatmentSystemOperational]:
    "1. Treatment system operational and functioning properly",
  [tokens.label.noDamageToComponents]:
    "2. No damage to tanks, pipes, pumps or major components",
  [tokens.label.clearSeparationEffluentRainwater]:
    "3. Clear separation between effluent and rainwater",
  [tokens.label.noBypassWithoutTreatment]:
    "4. No direct flow (bypass) without treatment",
  [tokens.label.chemicalsStoredProperly]:
    "5. Treatment chemicals stored properly",
  [tokens.label.treatmentAreaClean]: "6. Treatment area clean and tidy",

  [tokens.label.dischargePoint]: "Effluent Discharge Point",
  [tokens.label.dischargePointLabeled]:
    "1. Effluent discharge point identified and clearly labeled",
  [tokens.label.effluentFlowsApprovedChannel]:
    "2. Effluent flows only through approved channel",
  [tokens.label.noUncontrolledDischarge]:
    "3. No uncontrolled discharge / leakage",
  [tokens.label.nearbyWaterNotPolluted]:
    "4. Nearby drains, gutters or rivers not polluted",
  [tokens.label.samplingPointAccessible]:
    "5. Sample can be taken at discharge point (sampling point clear and safe)",

  [tokens.label.parameterCompliance]: "Parameter Compliance",
  [tokens.label.analysisShowsCompliance]:
    "1. Analysis results show compliance with license conditions",
  [tokens.label.correctiveActionTaken]:
    "2. Corrective action taken if non-compliance identified",
  [tokens.label.noUnauthorizedDischarge]:
    "3. No unauthorized discharge to environment",

  [tokens.label.safetyAndCleanliness]: "Safety and Cleanliness",
  [tokens.label.safeAccessToTreatment]:
    "1. Path to treatment system safe and easily accessible",
  [tokens.label.workersPPE]: "2. Workers wearing PPE when handling effluent",
  [tokens.label.noOpenChemicalDisposal]:
    "3. No open disposal of chemical waste",
  [tokens.label.warningSignsPresent]: "4. Area has warning and safety signage",

  [tokens.label.enforcement]: "Enforcement",
  [tokens.label.noticeSection70]: "1. Notice of Offense Section 70",
  [tokens.label.noticeSection30]: "2. Notice of Offense Section 30(1)",
  [tokens.label.noticeSection77]: "3. Notice of Offense Section 77",
  [tokens.label.noticeSection78]: "4. Notice of Offense Section 78",

  [tokens.label.insituSamplingReport]: "In-situ Sampling Report",
  [tokens.label.serialNumber]: "Serial Number",
  [tokens.label.enterSerialNumber]: "Enter serial number if issued",
  [tokens.label.noticeDetails]: "Notice Details",
  [tokens.label.specifyDetails]: "Specify further details if not compliant",
  [tokens.msg.samplingDataInNextSection]:
    "Sampling data will be filled in the next section (Sampling Information)",
  [tokens.label.uploadFile]: "Upload File",
  [tokens.label.remove]: "Remove",

  // Sampling Section
  [tokens.label.samplingInfo]: "Sampling Information",
  [tokens.label.sampleCollected]: "Sample Collected",
  [tokens.label.sampleId]: "Sample ID",
  [tokens.label.collectionDateTime]: "Collection Date & Time",
  [tokens.label.waterQualityParameters]: "Water Quality Parameters",
  [tokens.label.dissolvedOxygen]: "Dissolved Oxygen (DO) mg/L",
  [tokens.label.biochemicalOxygenDemand]:
    "Biochemical Oxygen Demand (BOD) mg/L",
  [tokens.label.chemicalOxygenDemand]: "Chemical Oxygen Demand (COD) mg/L",
  [tokens.label.ammoniacalNitrogen]: "Ammoniacal Nitrogen (NH3-N) mg/L",
  [tokens.label.suspendedSolids]: "Total Suspended Solids (TSS) mg/L",
  [tokens.label.phLevel]: "pH Level",
  [tokens.label.waterQualityIndex]: "Water Quality Index (WQI)",
  [tokens.label.wqiClass]: "WQI Class",
  [tokens.label.labReport]: "Laboratory Report",
  [tokens.label.uploadLabReport]: "Upload Lab Report (Optional)",
  [tokens.label.labReportLatest]:
    "Latest Laboratory Analysis Report (< 6 months) - Optional",

  // Images Section
  [tokens.label.siteImages]: "Site Images",
  [tokens.label.uploadImages]: "Upload Images",
  [tokens.label.maxImages]: "Maximum 5 images, max size 3MB each",
  [tokens.label.imageCaption]: "Image Caption",

  // Summary Sections
  [tokens.label.observationsSummary]: "Inspection Summary & Observations",
  [tokens.label.recommendationsSummary]: "Follow-up Actions / Corrections",
  [tokens.label.followUpActions]: "Confirmation of Actions Taken",
  [tokens.label.maxCharacters]: "Maximum 1000 characters",
  [tokens.label.charactersRemaining]: "characters remaining",

  // Actions & Status
  [tokens.label.saveDraft]: "Save Draft",
  [tokens.label.continueEditing]: "Continue Editing",
  [tokens.label.submitReport]: "Submit Report",
  [tokens.label.generatePDF]: "Generate PDF",
  [tokens.label.previewAndDownloadPDF]: "Preview and Download PDF",
  [tokens.label.markAsCompleted]: "Mark as Completed",
  [tokens.label.statusDraft]: "Draft",
  [tokens.label.statusCompleted]: "Completed",
  [tokens.label.statusGenerated]: "Generated",
  [tokens.label.lastSaved]: "Last Saved",
  [tokens.label.autoSave]: "Auto-save enabled",

  // Validation Messages
  [tokens.label.requiredField]: "This field is required",
  [tokens.label.invalidEmail]: "Invalid email address",
  [tokens.label.invalidPhone]: "Invalid phone number",
  [tokens.label.invalidCoordinates]: "Invalid GPS coordinates",
  [tokens.label.selectAtLeastOne]: "Please select at least one option",
  [tokens.label.allParametersRequired]:
    "All water quality parameters are required for WQI calculation",
  [tokens.label.pleaseFixRequiredFields]:
    "Please fill in the following required fields:",
  [tokens.label.fileNumberRequired]: "No. Siri LSANK (File Number) is required",
  [tokens.label.reportDateRequired]: "Report date is required",
  [tokens.label.inspectionDateRequired]: "Inspection date is required",
  [tokens.label.inspectionTimeRequired]: "Inspection time is required",
  [tokens.label.atLeastOneOfficerRequired]:
    "At least one inspection officer is required",
  [tokens.label.siteOfficerNameRequired]:
    "Site officer name (PIC Tapak) is required",
  [tokens.label.stationRequired]: "Station is required",
  [tokens.label.sourcePointRequired]: "Source point is required",
  [tokens.label.addressLine1Required]: "Address Line 1 is required",
  [tokens.label.sampleIdRequiredWhenCollected]:
    "Sample ID is required when sample is collected",
  [tokens.label.sampleDateRequiredWhenCollected]:
    "Sample collection date/time is required when sample is collected",
  [tokens.label.inspectionSummaryRequired]:
    "Inspection Summary (Rumusan & Ulasan Pemeriksaan) is required",
  [tokens.label.followUpActionsRequired]:
    "Follow-up Actions (Tindakan Susulan/Pembetulan) is required",
  [tokens.label.actionConfirmationRequired]:
    "Action Confirmation (Pengesahan Tindakan yang Diambil) is required",
  [tokens.label.viewInspectionReports]: "View Inspection Reports",
  [tokens.label.inspectionReports]: "Inspection Reports",
  [tokens.label.pdfGenerated]: "PDF generated successfully",
  [tokens.label.preview]: "Preview",
  [tokens.label.siteVisitDate]: "Site Visit Date",
  [tokens.label.siteVisitTime]: "Site Visit Time",
  [tokens.label.createdDate]: "Created Date",
  [tokens.label.officers]: "Officers",
  [tokens.label.activity]: "Activity",
  [tokens.label.created]: "Created",
  [tokens.label.updated]: "Updated",
  [tokens.label.reportType]: "Report Type",
};
